import React, { Component } from 'react';
import Page from '../../components/Page';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import moment from 'moment';
import { toWapi, post, get, postEx } from '../../util/api';
import { Button, Input, Segment, Table, Grid, GridColumn, Header, Modal, Icon, Tab, Dropdown, Checkbox, TextArea } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Telegram Bot API 9.4+ inline/reply button "style" (renk) değerleri. Boş = varsayılan renk.
const BUTTON_STYLE_OPTIONS = [
	{ key: 'none', text: 'Renk yok', value: '' },
	{ key: 'primary', text: '🔵 Mavi', value: 'primary' },
	{ key: 'success', text: '🟢 Yeşil', value: 'success' },
	{ key: 'danger', text: '🔴 Kırmızı', value: 'danger' },
];

class Phone extends Component {
	state = {
		phones: [],
		loading: true,
		targets: [],
		message_type: 'template',
		sw_groups: true,
		sw_contacts: false,
		start_date: new Date(),
		buttonRows: [[{ url: '', text: '', type: 'url' }]],
		btnSaving: false,
		headerText: '',
		headerUrl: '',
		headerHidden: false,
		headerStyle: '',
		reelsStyle: '',
		telegramConfig: null,
		mediaSaving: false,
		mediaUploading: null,
	};
	componentDidMount() {
		this.listSchedules();
		this.getData();
		this.initButtonRows();
		this.initTelegramConfig();
	}
	async getData() {
		let { t, shop } = this.props;
		await post('/shop/brand/list', { pid: shop.pid }).then((data) => {
			let result = data.data.result.data;
			let filtered_data = _.filter(result, (it) => it.link);
			this.setState({ brands: filtered_data, loading: false });
		});
	}
	async listSchedules() {
		let { shop } = this.props;
		await post('/shop/schedulelist', { pid: shop.pid }).then((data) => {
			let list = data.data.result;
			this.setState({ scheduleList: list });
		});
	}
	async sendMessage() {
		this.setState({ btnLoading: true });
		let { shop } = this.props;
		let { brands, planned, start_date } = this.state;
		let pid = shop.server_config.whatsapp.product_id;
		let key = shop.server_config.whatsapp.key;
		let keyword = shop.keyword;
		let show_videos = (shop.client_config && shop.client_config.show_videos) || false;
		let show_videos_title = shop.client_config && shop.client_config.show_videos_title;
		let button_count = (shop.server_config && shop.server_config.button_count && parseInt(shop.server_config.button_count)) || 3;
		let telegram = shop.server_config.telegram;
		let whatsapp_contact_message = shop.server_config.whatsapp_contact_message;
		let whatsapp_contact_message2 = shop.server_config.whatsapp_contact_message2;
		let whatsapp_contact_message3 = shop.server_config.whatsapp_contact_message3;
		let telegram_button_extra = shop.server_config.telegram_button_extra;
		let button_header_text = shop.server_config.button_header_text;
		let button_header_url = shop.server_config.button_header_url;
		let button_header_style = shop.server_config.button_header_style;
		let hide_header_button = shop.server_config.hide_header_button;
		let buttons = [];
		if (!hide_header_button)
			buttons.push([{ text: button_header_text || 'WHATSAPP SHOP 👗', url: button_header_url || `https://${shop.keyword}.whatsapp-shop.com`, type: 'url', ...(button_header_style ? { style: button_header_style } : {}) }]);

		if (telegram_button_extra) buttons.push(...telegram_button_extra);
		if (shop.server_config.no_web_url) buttons = [];

		if (whatsapp_contact_message) {
			buttons.push([
				{
					text: 'WHATSAPP CONTACT',
					url: whatsapp_contact_message,
					type: 'url',
				},
			]);
		}

		if (whatsapp_contact_message2) {
			buttons.push([
				{
					text: 'WHATSAPP CONTACT - 2',
					url: whatsapp_contact_message2,
					type: 'url',
				},
			]);
		}
		if (whatsapp_contact_message3) {
			buttons.push([
				{
					text: 'WHATSAPP CONTACT - 3',
					url: whatsapp_contact_message3,
					type: 'url',
				},
			]);
		}
		let reels_button_style = shop.server_config.reels_button_style;
		if (show_videos) {
			buttons.push([
				{
					text: show_videos_title ? show_videos_title : (keyword && _.upperCase(keyword) + ' REELS 🎥') || 'REELS 🎥',
					url: `https://${shop.keyword}.whatsapp-shop.com/reels`,
					...(reels_button_style ? { style: reels_button_style } : {}),
					type: 'url',
				},
			]);
		}
		let buttons_sale_fire = shop.server_config.buttons_sale_fire;
		let telegram_format_data = _.map(
			_.filter(brands, (o) => o.active || o.link === 'https://t.me/+0WjuL2v6NjE4M2Jk'),
			(it) => ({
				text: buttons_sale_fire && it.name === 'SALE' ? '🔥🔥🔥 SALE 🔥🔥🔥' : it.name,
				url: it.link,
				...(it.style ? { style: it.style } : {}),
				type: 'url',
			})
		);
		for (let index = 0; index < telegram_format_data.length; index = index + button_count) {
			let temp = _.slice(telegram_format_data, index, index + button_count);
			buttons.push(temp);
		}
		let isArray = _.isArray(telegram);
		if (!isArray) {
			let body = {
				to_number: telegram.main_group,
				type: 'text',
				message: telegram.buttons_message,
				buttons,
			};
			if (telegram.video_url) {
				body = {
					to_number: telegram.main_group,
					type: /mp4|mov/.test(telegram.video_url) ? 'video' : 'media',
					text: telegram.buttons_message,
					message: telegram.video_url,
					buttons,
				};
			}
			if (planned) {
				await post('/shop/addscheduletelegram', { pid: shop.pid, time: start_date }).then(() => this.listSchedules());
			} else {
				if (telegram.new_telegram) {
					await postEx(`https://app.dialogtab.com/api/telegram/sendMessage/${pid}/${telegram.telegram_id}`, body)
						.then((data) => {
							if (data.status !== 200) {
								return;
							}
							return data;
						})
						.catch((err) => {
							console.error(err);
						});
				} else {
					await toWapi(`/api/${pid}/${telegram.telegram_id}/sendMessage`, key, body)
						.then((data) => {
							if (data.status !== 200) {
								return;
							}
							return data;
						})
						.catch((err) => {
							console.error(err);
						});
				}
			}
		} else {
			if (planned) {
				await post('/shop/addscheduletelegram', { pid: shop.pid, time: start_date }).then(() => this.listSchedules());
			} else {
				for (let i = 0; i < telegram.length; i++) {
					let element = telegram[i];
					let body = {
						to_number: element.main_group,
						type: 'text',
						message: element.buttons_message,
						buttons,
					};
					if (element.video_url) {
						body = {
							to_number: element.main_group,
							type: /mp4|mov/.test(element.video_url) ? 'video' : 'media',
							text: element.buttons_message,
							message: element.video_url,
							buttons,
						};
					}
					if (element.nobuttons) {
						body = _.pick(body, ['to_number', 'type', 'text', 'message']);
					}
					if (element.new_telegram) {
						await postEx(`https://app.dialogtab.com/api/telegram/sendMessage/${pid}/${element.telegram_id}`, body)
							.then((data) => {
								if (data.status !== 200) {
									return;
								}
								return data;
							})
							.catch((err) => {
								console.error(err);
							});
					} else {
						await toWapi(`/api/${pid}/${element.telegram_id}/sendMessage`, key, body)
							.then((data) => {
								if (data.status !== 200) {
									return;
								}
								return data;
							})
							.catch((err) => {
								console.error(err);
							});
					}
				}
			}
		}
		this.setState({ btnLoading: false, openModal: false });
	}

	async sendMessage2() {
		this.setState({ btnLoading: true });
		let { shop } = this.props;
		let { planned, start_date } = this.state;
		let pid = shop.server_config.whatsapp.product_id;
		let key = shop.server_config.whatsapp.key;
		let telegram = shop.server_config.telegram1;
		let buttons = [];

		if (planned) {
			await post('/shop/addschedulestatictelegram', { pid: shop.pid, time: start_date }).then(() => this.listSchedules());
		} else {
			for (let i = 0; i < telegram.length; i++) {
				let element = telegram[i];
				buttons = element.buttons;
				let body = {
					to_number: element.main_group,
					type: 'text',
					message: element.buttons_message,
					buttons,
				};
				if (element.video_url) {
					body = {
						to_number: element.main_group,
						type: /mp4|mov/.test(element.video_url) ? 'video' : 'media',
						text: element.buttons_message,
						message: element.video_url,
						buttons,
					};
				}
				if (element.nobuttons) {
					body = _.pick(body, ['to_number', 'type', 'text', 'message']);
				}
				if (telegram.new_telegram) {
					await postEx(`https://app.dialogtab.com/api/telegram/sendMessage/${pid}/${telegram.telegram_id}`, body)
						.then((data) => {
							if (data.status !== 200) {
								return;
							}
							return data;
						})
						.catch((err) => {
							console.error(err);
						});
				} else {
					await toWapi(`/api/${pid}/${element.telegram_id}/sendMessage`, key, body)
						.then((data) => {
							if (data.status !== 200) {
								return;
							}
							return data;
						})
						.catch((err) => {
							console.error(err);
						});
				}
			}
		}
		this.setState({ btnLoading: false, openModal: false });
	}
	async cancelSchedule() {
		let { shop } = this.props;
		await post('/shop/cancelschedule', { pid: shop.pid }).then(() => this.listSchedules());
		this.setState({ btnLoading: false, openDeleteModal: false });
	}
	initButtonRows() {
		let { shop } = this.props;
		let existing = (shop && shop.server_config && shop.server_config.telegram_button_extra) || [];
		let buttonRows = existing.length ? _.cloneDeep(existing) : [[{ url: '', text: '', type: 'url' }]];
		let sc = (shop && shop.server_config) || {};
		this.setState({
			buttonRows,
			headerText: sc.button_header_text || '',
			headerUrl: sc.button_header_url || '',
			headerHidden: !!sc.hide_header_button,
			headerStyle: sc.button_header_style || '',
			reelsStyle: sc.reels_button_style || '',
		});
	}
	updateButton(rowIndex, btnIndex, field, value) {
		let updated = _.cloneDeep(this.state.buttonRows);
		updated[rowIndex][btnIndex][field] = value;
		this.setState({ buttonRows: updated });
	}
	addButtonToRow(rowIndex, afterIndex) {
		let updated = _.cloneDeep(this.state.buttonRows);
		updated[rowIndex].splice(afterIndex + 1, 0, { url: '', text: '', type: 'url' });
		this.setState({ buttonRows: updated });
	}
	removeButton(rowIndex, btnIndex) {
		let updated = _.cloneDeep(this.state.buttonRows);
		updated[rowIndex].splice(btnIndex, 1);
		if (updated[rowIndex].length === 0) updated.splice(rowIndex, 1);
		if (updated.length === 0) updated = [[{ url: '', text: '', type: 'url' }]];
		this.setState({ buttonRows: updated });
	}
	addRow() {
		let updated = _.cloneDeep(this.state.buttonRows);
		updated.push([{ url: '', text: '', type: 'url' }]);
		this.setState({ buttonRows: updated });
	}
	insertRow(index) {
		let updated = _.cloneDeep(this.state.buttonRows);
		updated.splice(index, 0, [{ url: '', text: '', type: 'url' }]);
		this.setState({ buttonRows: updated });
	}
	async saveTelegramButtons() {
		this.setState({ btnSaving: true });
		let { shop } = this.props;
		let { buttonRows, headerText, headerUrl, headerHidden, headerStyle, reelsStyle } = this.state;
		let filtered = buttonRows
			.map((row) =>
				row
					.map((btn) => {
						let clean = { ...btn, url: btn.url.replace(/\s|%20/g, '') };
						if (!clean.style) delete clean.style;
						return clean;
					})
					.filter((btn) => btn.url || btn.text)
			)
			.filter((row) => row.length > 0);
		await post('/shop/serverConfig/upsert', {
			data: {
				telegram_button_extra: filtered,
				button_header_text: headerText || '',
				button_header_url: (headerUrl || '').replace(/\s|%20/g, ''),
				hide_header_button: !!headerHidden,
				button_header_style: headerStyle || '',
				reels_button_style: reelsStyle || '',
			},
		}).catch((err) => console.error(err));
		this.setState({ btnSaving: false });
		window.location.reload();
	}
	initTelegramConfig() {
		let { shop } = this.props;
		let tg = (shop && shop.server_config && shop.server_config.telegram) || null;
		this.setState({ telegramConfig: tg ? _.cloneDeep(tg) : null });
	}
	telegramGroups() {
		let tg = this.state.telegramConfig;
		if (!tg) return [];
		return _.isArray(tg) ? tg : [tg];
	}
	updateTelegramField(groupIndex, field, value) {
		let tg = _.cloneDeep(this.state.telegramConfig);
		if (_.isArray(tg)) tg[groupIndex][field] = value;
		else tg[field] = value;
		this.setState({ telegramConfig: tg });
	}
	async uploadMedia(file, groupIndex) {
		if (!file) return;
		this.setState({ mediaUploading: groupIndex });
		try {
			const formData = new FormData();
			formData.append('files[]', file);
			let resp = await fetch('https://uploads.yapaytech.com/flow/uploadPermImage', { method: 'post', body: formData });
			let data = await resp.json();
			let url = data && data.files && data.files[0] && data.files[0].url;
			if (url) this.updateTelegramField(groupIndex, 'video_url', url);
		} catch (err) {
			console.error(err);
		}
		this.setState({ mediaUploading: null });
	}
	async saveTelegramContent() {
		this.setState({ mediaSaving: true });
		let { telegramConfig } = this.state;
		await post('/shop/serverConfig/upsert', { data: { telegram: telegramConfig } }).catch((err) => console.error(err));
		this.setState({ mediaSaving: false });
		window.location.reload();
	}
	renderMediaEditor() {
		let { t } = this.props;
		let groups = this.telegramGroups();
		let { mediaSaving, mediaUploading } = this.state;
		return (
			<Tab.Pane>
				<p>Gönderilecek mesajın metnini ve (isteğe bağlı) resim/video medyasını buradan ayarlayın. mp4/mov → video, diğer dosyalar → foto olarak gönderilir.</p>
				{!groups.length && <Segment>Telegram grubu tanımlı değil.</Segment>}
				{groups.map((g, i) => {
					let isVideo = g.video_url && /mp4|mov/i.test(g.video_url);
					return (
						<Segment key={i}>
							<Header as="h5">{g.main_group ? 'Grup: ' + g.main_group : 'Telegram Grubu ' + (i + 1)}</Header>
							<div style={{ marginBottom: '10px' }}>
								<label style={{ fontSize: '12px', color: '#666' }}>Mesaj metni (caption)</label>
								<TextArea
									style={{ width: '100%', minHeight: '90px', marginTop: '4px' }}
									value={g.buttons_message || ''}
									onChange={(e) => this.updateTelegramField(i, 'buttons_message', e.target.value)}
								/>
							</div>
							<div style={{ display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap' }}>
								<Input
									size="small"
									label="Medya URL"
									placeholder="https://... (resim veya mp4/mov)"
									value={g.video_url || ''}
									onChange={(e) => this.updateTelegramField(i, 'video_url', e.target.value.trim())}
									style={{ flex: 1, minWidth: '280px' }}
								/>
								<input
									type="file"
									accept="image/*,video/mp4,video/quicktime"
									id={`media-upload-${i}`}
									style={{ display: 'none' }}
									onChange={(e) => this.uploadMedia(e.target.files[0], i)}
								/>
								<Button as="label" htmlFor={`media-upload-${i}`} size="small" basic icon="upload" loading={mediaUploading === i} content="Yükle" />
								{g.video_url && <Button size="small" basic color="red" icon="trash" onClick={() => this.updateTelegramField(i, 'video_url', '')} />}
							</div>
							{g.video_url ? (
								<div style={{ marginTop: '10px' }}>
									{isVideo ? (
										<video src={g.video_url} controls style={{ maxWidth: '240px', maxHeight: '180px' }} />
									) : (
										<img src={g.video_url} alt="media" style={{ maxWidth: '240px', maxHeight: '180px', objectFit: 'contain' }} />
									)}
								</div>
							) : null}
						</Segment>
					);
				})}
				{groups.length ? (
					<Button primary loading={mediaSaving} onClick={() => this.saveTelegramContent()}>
						{t('save')}
					</Button>
				) : null}
			</Tab.Pane>
		);
	}
	closeModal = () => {
		this.setState({ openModal: false, planed: false, openDeleteModal: false });
	};
	render() {
		let { loading, scheduleList, start_date, selected_index } = this.state;
		let { t, shop } = this.props;

		let groups = [
			{
				number: 0,
				name: 'Markalar Şablonu',
				id: '-1001602838599',
			},
		];
		if (shop && shop.server_config && shop.server_config.telegram1)
			groups.push({
				number: 1,
				name: 'Bilgi Şablonu',
				id: '-1001602838599',
			});
		console.log('shop', scheduleList);
		if (loading) return <Page.Loader></Page.Loader>;
		const panes = [
			{
				menuItem: 'Mesaj Gönder',
				render: () => (
					<Tab.Pane>
						<Table>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>{t('name')}</Table.HeaderCell>
									<Table.HeaderCell></Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{_.map(groups, (it) => (
									<Table.Row>
										<Table.Cell>{it.name}</Table.Cell>
										<Table.Cell textAlign={'right'}>
											<Button positive onClick={() => this.setState({ openModal: true, selected_index: it.number })}>
												{t('sendTemplate')}
											</Button>
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table>
					</Tab.Pane>
				),
			},
			{
				menuItem: t('telegramButtons') + ' (' + t('fixed') + ')',
				render: () => {
					let { buttonRows, btnSaving } = this.state;
					return (
						<Tab.Pane>
							<p>{t('telegramButtonsDesc')}</p>
								<p style={{ color: '#999', fontSize: '12px', marginTop: '-6px' }}>
									Renk (Telegram Bot API 9.4+) yalnızca gönderim altyapısı destekliyorsa görünür; desteklenmezse buton varsayılan renkte gösterilir.
								</p>
							<Segment style={{ background: '#eef6ff', border: '1px solid #cfe2ff', marginTop: '8px' }}>
									<Checkbox
										toggle
										label="Üst buton (WHATSAPP SHOP) gösterilsin"
										checked={!this.state.headerHidden}
										onChange={(e, { checked }) => this.setState({ headerHidden: !checked })}
									/>
									{!this.state.headerHidden && (
										<div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center', marginTop: '10px' }}>
											<Input
												size="small"
												label="Metin"
												placeholder="WHATSAPP SHOP 👗"
												value={this.state.headerText}
												onChange={(e) => this.setState({ headerText: e.target.value })}
												style={{ width: '260px' }}
											/>
											<Input
												size="small"
												label="URL"
												placeholder={`https://${shop.keyword}.whatsapp-shop.com`}
												value={this.state.headerUrl}
												onChange={(e) => this.setState({ headerUrl: e.target.value.replace(/\s|%20/g, '') })}
												style={{ width: '360px' }}
											/>
										</div>
									)}
								</Segment>
								<Segment style={{ background: '#f0fff4', border: '1px solid #cbead6', marginTop: '8px' }}>
									<label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '6px' }}>Buton renkleri (Telegram)</label>
									<div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
										<div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
											<span style={{ fontSize: '13px' }}>Üst buton:</span>
											<Dropdown
												selection
												compact
												options={BUTTON_STYLE_OPTIONS}
												value={this.state.headerStyle || ''}
												onChange={(e, { value }) => this.setState({ headerStyle: value })}
												style={{ minWidth: '110px' }}
											/>
										</div>
										<div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
											<span style={{ fontSize: '13px' }}>Reels butonu:</span>
											<Dropdown
												selection
												compact
												options={BUTTON_STYLE_OPTIONS}
												value={this.state.reelsStyle || ''}
												onChange={(e, { value }) => this.setState({ reelsStyle: value })}
												style={{ minWidth: '110px' }}
											/>
										</div>
									</div>
									<p style={{ fontSize: '12px', color: '#999', marginTop: '6px', marginBottom: 0 }}>
										Marka butonlarının rengi Markalar sayfasından her marka için ayrı ayarlanır.
									</p>
								</Segment>
								<div style={{ marginTop: '8px' }}>
								{buttonRows.map((row, rowIndex) => (
									<React.Fragment key={rowIndex}>
										{rowIndex > 0 && (
											<div style={{ display: 'flex', alignItems: 'center', margin: '2px 0' }}>
												<div style={{ flex: 1, height: '1px', background: '#d0d0d0' }} />
												<Button
													icon="plus"
													size="mini"
													circular
													basic
													color="grey"
													style={{ margin: '0 6px' }}
													onClick={() => this.insertRow(rowIndex)}
												/>
												<div style={{ flex: 1, height: '1px', background: '#d0d0d0' }} />
											</div>
										)}
										<div
											style={{
											display: 'flex',
											alignItems: 'center',
											marginBottom: '10px',
											flexWrap: 'wrap',
											gap: '6px',
											padding: '10px',
											background: '#f7f7f7',
											borderRadius: '6px',
											border: '1px solid #e0e0e0',
										}}
									>
										{row.map((btn, btnIndex) => (
											<div key={btnIndex} style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
												<Input
													size="small"
													placeholder="Text"
													value={btn.text}
													onChange={(e) => this.updateButton(rowIndex, btnIndex, 'text', e.target.value)}
													style={{ width: '130px' }}
												/>
												<Input
													size="small"
													placeholder="URL"
													value={btn.url}
													onChange={(e) => this.updateButton(rowIndex, btnIndex, 'url', e.target.value.replace(/\s|%20/g, ''))}
													style={{ width: '220px' }}
												/>
												<Input
													size="small"
													placeholder="Type"
													value={btn.type}
													onChange={(e) => this.updateButton(rowIndex, btnIndex, 'type', e.target.value)}
													style={{ width: '80px' }}
												/>
												<Dropdown
													selection
													compact
													options={BUTTON_STYLE_OPTIONS}
													value={btn.style || ''}
													onChange={(e, { value }) => this.updateButton(rowIndex, btnIndex, 'style', value)}
													style={{ minWidth: '110px' }}
												/>
												<Button
													icon="times"
													size="mini"
													basic
													color="red"
													onClick={() => this.removeButton(rowIndex, btnIndex)}
												/>
												{(btn.text || btn.url) && (
													<Button
														icon="plus"
														size="mini"
														basic
														color="blue"
														onClick={() => this.addButtonToRow(rowIndex, btnIndex)}
													/>
												)}
											</div>
										))}
									</div>
								</React.Fragment>
								))}
								<div style={{ marginBottom: '12px' }}>
									<Button size="small" basic icon="plus" content={t('addRow')} onClick={() => this.addRow()} />
								</div>
								<Button primary loading={btnSaving} onClick={() => this.saveTelegramButtons()}>
									{t('save')}
								</Button>
							</div>
						</Tab.Pane>
					);
				},
			},
			{
				menuItem: t('Schedule'),
				render: () => (
					<Tab.Pane>
						<Table>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>{t('name')}</Table.HeaderCell>
									<Table.HeaderCell width={1}></Table.HeaderCell>
									<Table.HeaderCell width={2}></Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{_.map(groups, (it) => (
									<Table.Row>
										<Table.Cell>{it.name}</Table.Cell>

										<Table.Cell textAlign={'right'}>
											<DatePicker
												selected={start_date}
												onChange={(date) => this.setState({ start_date: date })}
												showTimeSelect
												showTimeSelectOnly
												timeFormat="HH:mm"
												timeIntervals={15}
												timeCaption={t('time')}
												dateFormat="HH:mm"
											/>
										</Table.Cell>
										<Table.Cell textAlign={'right'}>
											<Button positive onClick={() => this.setState({ openModal: true, planned: true, selected_index: it.number })}>
												{t('schedule')}
											</Button>
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table>
						<br />
						{scheduleList && scheduleList.length ? (
							<>
								<p>{t('scheduleList')}</p>
								<Table>
									<Table.Header>
										<Table.Row>
											<Table.HeaderCell>{t('name')}</Table.HeaderCell>
											<Table.HeaderCell>{t('createDate')}</Table.HeaderCell>
											<Table.HeaderCell>{t('runTime')}</Table.HeaderCell>
											<Table.HeaderCell></Table.HeaderCell>
										</Table.Row>
									</Table.Header>
									<Table.Body>
										{_.map(scheduleList, (it) => {
											let cron = it.cron.split(' ');
											let hour = cron[1];
											let min = cron[0] === '0' ? '00' : cron[0];
											return (
												<Table.Row>
													<Table.Cell>Markalar Şablonu</Table.Cell>
													<Table.Cell>{moment(it.created_on).format('DD-MM-YYYY HH:mm')}</Table.Cell>
													<Table.Cell>{`${t('everyday')} ${hour}:${min}`}</Table.Cell>
													<Table.Cell style={{ textAlign: 'right' }}>
														<Button negative onClick={() => this.setState({ openDeleteModal: true })}>
															{t('delete')}
														</Button>
													</Table.Cell>
												</Table.Row>
											);
										})}
									</Table.Body>
								</Table>
							</>
						) : null}
					</Tab.Pane>
				),
			},
			{
				menuItem: 'Medya & Mesaj',
				render: () => this.renderMediaEditor(),
			},
		];
		return (
			<Page title={'Telegram'} icon="telegram">
				<Page.Wrap>
					<Grid>
						<GridColumn width={16}>
							<Segment className="scroll">
								<div style={{ display: 'flex', marginBottom: '10px' }}>
									<div style={{ display: 'flex', alignItems: 'center' }}>
										<Header>{t('Telegram Grup')}</Header>
									</div>
								</div>
								<Tab panes={panes} />
							</Segment>
						</GridColumn>
					</Grid>
					<Modal open={this.state.openModal} onClose={this.closeModal} style={{ width: '900px', maxHeight: '600px' }}>
						<Header icon="telegram" content={t('sendMessage')} />
						<Modal.Content>
							<p style={{ display: 'flex', alignItems: 'center' }}>{this.state.planned ? t('plannedTelegramSure') : t('sendTelegramsSure')}</p>
						</Modal.Content>
						<Modal.Actions>
							<div style={{ display: 'flex' }}>
								<div style={{ marginLeft: 'auto' }}>
									<Button color="red" onClick={this.closeModal}>
										<Icon name="remove" /> {t('no')}
									</Button>
									<Button
										color="green"
										onClick={() => {
											if (selected_index == 0) this.sendMessage();
											else if (selected_index == 1) this.sendMessage2();
										}}
									>
										<Icon name="checkmark" /> {t('yes')}
									</Button>
								</div>
							</div>
						</Modal.Actions>
					</Modal>
					<Modal open={this.state.openDeleteModal} onClose={this.closeModal} style={{ width: '900px', maxHeight: '600px' }}>
						<Header icon="telegram" content={t('cancelSchedule')} />
						<Modal.Content>
							<p style={{ display: 'flex', alignItems: 'center' }}>{t('deleteScheduleQuestion')}</p>
						</Modal.Content>
						<Modal.Actions>
							<div style={{ display: 'flex' }}>
								<div style={{ marginLeft: 'auto' }}>
									<Button color="red" onClick={this.closeModal}>
										<Icon name="remove" /> {t('no')}
									</Button>
									<Button color="green" onClick={() => this.cancelSchedule()}>
										<Icon name="checkmark" /> {t('yes')}
									</Button>
								</div>
							</div>
						</Modal.Actions>
					</Modal>
				</Page.Wrap>
			</Page>
		);
	}
}
export default connect((state) => ({ shop: state.product.shop }))(withTranslation()(Phone));
